import React from 'react'

import { theme } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT, fonts, publishingColors } from '../../styles'
import { usePotential } from '../PotentialContext'

const Container = styled.ul`
  display: grid;
  grid-template-rows: 1fr 1fr;
  margin: 0;
  padding: 0;
  row-gap: 10px;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    position: absolute;
  }
`

const Row = styled.li`
  align-items: center;
  display: flex;
`

const Dot = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  border-radius: 5px;
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
`

const Text = styled.span`
  ${fonts.AN_12_500_16}
  color: ${theme.colors.white};
  font-weight: 400;
`

const Value = styled.span`
  font-weight: 600;
`

export const AccountValueBreakdown = (): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()
  const { returnValue, netInvestments } = usePotential()

  return (
    <Container>
      <Row>
        <Dot bgColor={publishingColors.tan} />
        <Text>
          {getRemoteString({ key: 'early.recap.potential.investment' })}{' '}
          <Value>{netInvestments}</Value>
        </Text>
      </Row>
      <Row>
        <Dot bgColor={theme.colors.bark} />
        <Text>
          {getRemoteString({ key: 'early.recap.potential.return' })}{' '}
          <Value>{returnValue}</Value>
        </Text>
      </Row>
    </Container>
  )
}
